import { doodModalConfig } from './dood-modal-config';
import { propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const ZEROSIXREGISTRATIONMODAL_LEGACY_FIELD_ORDER = [
  { type: 'heading', value: "Comportement" },
  "go_to_u_r_l_on_close",
  "go_to_kiosk_register",
  "active_step",
  { type: 'heading', value: "Couleurs" },
  "background_color",
  "action_font_color",
  "action_background_color"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  zerosixRegistrationModalDescriptor: _generatedZerosixRegistrationModalDescriptor,
  zerosixRegistrationModalModalDefinition,
  zerosixRegistrationModalDashboardLayout,
  zerosixRegistrationModalConfig,
  zerosixRegistrationModalResolveConfig,
  zerosixRegistrationModalProperties,
} = doodModalConfig(
  {
    name: "Zerosix - Registration modal",
    handle: "zerosix-registration-modal",
    internal_name: "ZerosixRegistrationModal",
    componentType: 'ZerosixRegistrationModalComponent',
    category: 'modal',
    description: "Zerosix - Registration modal.",
    keywords: [],
    isContentModal: true,
    defaultHandle: "zerosix-registration-modal",
    allowed_in: ["ModalBlock"],
    sharedFields: {}
  },

  () => ({
    background_color: propertyValue({
      type: 'color',
      value: {"type":"hex","value":"#FFFFFF"},
      options: {
        "label": "Couleur de fond"
      }
    }),
    go_to_u_r_l_on_close: propertyValue({
      type: 'link',
      value: '',
      options: {
        "label": "URL de redirection à la fermeture",
        "help": "Choisissez une page ou un point de vente, saisissez une URL externe ou revenez à la page précédente. Laisser vide pour ne pas rediriger.",
        "defaultMode": "page",
        "modes": ["page", "external", "navigationBack"]
      }
    }),
    go_to_kiosk_register: propertyValue({
      type: 'checkbox',
      value: false,
      options: {
        "label": "Ouvrir directement l'étape d'inscription kiosk"
      }
    }),
    active_step: propertyValue({
      type: 'select',
      value: "ZEROSIX_STEP_PHONE",
      options: {
        "label": "Étape initiale",
        "choices": [
          {
            "value": "ZEROSIX_STEP_PHONE",
            "label": "Téléphone"
          },
          {
            "value": "ZEROSIX_STEP_OTP",
            "label": "Code OTP"
          },
          {
            "value": "ZEROSIX_STEP_AUTHENTICATION",
            "label": "Authentification"
          },
          {
            "value": "ZEROSIX_STEP_ACCOUNT_NOT_FOUND",
            "label": "Compte introuvable"
          },
          {
            "value": "ZEROSIX_STEP_KIOSK_CONFIRMATION",
            "label": "Kiosk — confirmation"
          },
          {
            "value": "ZEROSIX_STEP_KIOSK_REGISTER",
            "label": "Kiosk — inscription"
          },
          {
            "value": "ZEROSIX_STEP_KIOSK_REGISTER_CONFIRMATION",
            "label": "Kiosk — confirmation inscription"
          },
          {
            "value": "ZEROSIX_STEP_KIOSK_REGISTRATION_SUCCESS",
            "label": "Kiosk — inscription réussie"
          },
          {
            "value": "ZEROSIX_STEP_KIOSK_ACCOUNT_NOT_FOUND",
            "label": "Kiosk — compte introuvable"
          }
        ]
      }
    }),
    action_font_color: propertyValue({
      type: 'color',
      value: { type: 'default', value: '' },
      options: {
        "label": "Couleur du texte des actions"
      }
    }),
    action_background_color: propertyValue({
      type: 'color',
      value: { type: 'default', value: '' },
      options: {
        "label": "Couleur de fond des actions"
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: 'Design',
        fieldsets: [
          {
            legend: 'Properties',
            fields: ["background_color", 
              "go_to_u_r_l_on_close",
              "go_to_kiosk_register",
              "active_step",
              "action_font_color",
              "action_background_color",
            ],
          },
        ],
      },
    ],
  })
);

export function zerosixRegistrationModalDescriptor(): IBlockDescriptor;
export function zerosixRegistrationModalDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function zerosixRegistrationModalDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedZerosixRegistrationModalDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedZerosixRegistrationModalDescriptor, zerosixRegistrationModalProperties, fieldOrder);
}

export {
  zerosixRegistrationModalModalDefinition,
  zerosixRegistrationModalDashboardLayout,
  zerosixRegistrationModalProperties,
  zerosixRegistrationModalConfig,
  zerosixRegistrationModalResolveConfig,
};

export type ZerosixRegistrationModalConfig = typeof zerosixRegistrationModalConfig;
